// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__cRKs-","header":"MessagesList_header__2-qLG","chat":"MessagesList_chat__15Zju"};